import generateUUID from '../../../_utils/math/generateUUID'
import Geometry from './Geometry'
import InstancedGeometry from './InstancedGeometry'
import Attribute from './Attribute'
import InstancedAttribute from './InstancedAttribute'

export default class InstancedGeometryBuilder {
  constructor(baseGeometry, numInstances, gl) {
    this._ext = gl.getExtension('ANGLE_instanced_arrays');
    this._baseGeometry = baseGeometry;
    this._geometry = null;
    this._isPseudo = false;
    this._numInstances = numInstances;
    this._numPositions = this._baseGeometry.attributes.position.count;

    if(this._ext) {
      // instance
      this._geometry = new InstancedGeometry();
      this._geometry.numInstances = this._numInstances;
      this._geometry.setExt(this._ext);

      const posAttribute = this._baseGeometry.attributes.position.clone();
      posAttribute.dynamic = true;
      this._geometry.addAttribute('position', posAttribute);
      this._geometry.addAttribute('uv', this._baseGeometry.attributes.uv.clone());
      this._geometry.addAttribute('normal', this._baseGeometry.attributes.normal.clone());
      this._geometry.setIndex(this._baseGeometry.index.clone());

    } else {
      // 疑似instance
      this._isPseudo = true;
      this._geometry = new Geometry();

      this._setPseudoAttribute('position');
      this._setPseudoAttribute('uv');
      this._setPseudoAttribute('normal');
      this._setPseudoIndex();
    }

    let randomValues = [];  // itemSize = 4
    let instanceIndex = [];  // itemSize = 1
    for (let i = 0; i < this._numInstances; i++) {
      instanceIndex.push(i);
      randomValues.push(this._getRandomValue());
      randomValues.push(this._getRandomValue());
      randomValues.push(this._getRandomValue());
      randomValues.push(this._getRandomValue());
    }

    this.setAttribute('randomValues', randomValues, Float32Array, 4, 1);
    this.setAttribute('instanceIndex', instanceIndex, Float32Array, 1, 1);
  }

  setAttribute(name, baseArray, ArrayType, itemSize, divisor = 1, dynamic = false) {
    let attribute;
    if(this._isPseudo) {
      let array = [];
      for (let i = 0; i < this._numInstances; i++) {
        for (let j = 0, l = this._numPositions; j < l; j++) {
          for (let k = 0; k < itemSize; k++) {
            array.push(baseArray[i * itemSize + k]);
          }
        }
      }
      attribute = new Attribute(new ArrayType(array), itemSize);
    } else {
      attribute = new InstancedAttribute(new ArrayType(baseArray), itemSize, divisor);
    }
    attribute.dynamic = dynamic;
    this._geometry.addAttribute(name, attribute);
  }

  updateAttribute(name, baseArray, ArrayType) {
    if(this._isPseudo) {
      let array = [];
      for (let i = 0; i < this._numInstances; i++) {
        for (let j = 0, l = this._numPositions; j < l; j++) {
          for (let k = 0; k < itemSize; k++) {
            array.push(baseArray[i * itemSize + k]);
          }
        }
      }
      this._geometry.updateAttribute(name, new ArrayType(array));
    } else {
      this._geometry.updateAttribute(name, new ArrayType(baseArray));
    }
  }

  getGeometry() {
    return this._geometry;
  }

  _getRandomValue() {
    return (Math.random() + Math.random() + Math.random()) / 3;
  }

  _setPseudoAttribute(name) {
    const attribute = this._baseGeometry.attributes[name];
    const baseArray = Array.prototype.slice.call(attribute.array);
    let array = [];
    for (let i = 0; i < this._numInstances; i++) {
      array = array.concat(baseArray);
    }
    this._geometry.addAttribute(name, new Attribute(new Float32Array(array), attribute.itemSize));
  }

  _setPseudoIndex() {
    const baseArray = Array.prototype.slice.call(this._baseGeometry.index.array);
    let array = [];
    for (let i = 0; i < this._numInstances; i++) {
      for (let j = 0, l = this._baseGeometry.index.count; j < l; j++) {
        array.push(i * this._numPositions + baseArray[j]);
      }
    }
    this._geometry.setIndex(new Attribute(new Uint16Array(array), 1));
  }
}
